// Shared constants for manual claim request UI — avoids duplicating strings
// across table, filter, detail, and form components.
// Values must stay in sync with ManualClaimRequestStatus / ManualClaimItemStatus /
// ManualClaimSubmissionType enums in redflag-node-utility.

export const MANUAL_CLAIM_REQUEST_STATUS = {
  CLAIM_REQUESTED: 'claim_requested',
  UNDER_REVIEW: 'under_review',
  COMPLETED: 'completed',
};

export const MANUAL_CLAIM_ITEM_STATUS = {
  PENDING: 'pending',
  MONETIZED: 'monetized',
  TAKENDOWN: 'takendown',
  REJECTED: 'rejected',
};

export const MANUAL_CLAIM_SUBMISSION_TYPE = {
  URL_INPUT: 'url_input',
  CSV_UPLOAD: 'csv_upload',
};

/** Options for the status filter dropdown (tables). */
export const MANUAL_CLAIM_REQUEST_STATUS_OPTIONS = [
  { api: MANUAL_CLAIM_REQUEST_STATUS.CLAIM_REQUESTED, display: 'Claim requested' },
  { api: MANUAL_CLAIM_REQUEST_STATUS.UNDER_REVIEW, display: 'Under review' },
  { api: MANUAL_CLAIM_REQUEST_STATUS.COMPLETED, display: 'Completed' },
];

/** Statuses available when an admin updates a request (excludes rejected — handled per item). */
export const ADMIN_EDITABLE_REQUEST_STATUSES = [
  MANUAL_CLAIM_REQUEST_STATUS.CLAIM_REQUESTED,
  MANUAL_CLAIM_REQUEST_STATUS.UNDER_REVIEW,
  MANUAL_CLAIM_REQUEST_STATUS.COMPLETED,
];

/** Per-item status options: depends on the claim's action type. */
export const MANUAL_CLAIM_ITEM_STATUS_OPTIONS_BY_TYPE = {
  monetize: [
    MANUAL_CLAIM_ITEM_STATUS.PENDING,
    MANUAL_CLAIM_ITEM_STATUS.MONETIZED,
    MANUAL_CLAIM_ITEM_STATUS.REJECTED,
  ],
  takedown: [
    MANUAL_CLAIM_ITEM_STATUS.PENDING,
    MANUAL_CLAIM_ITEM_STATUS.TAKENDOWN,
    MANUAL_CLAIM_ITEM_STATUS.REJECTED,
  ],
};

/** Fallback when claim_action_type is unknown. */
export const MANUAL_CLAIM_ITEM_STATUS_OPTIONS = [
  MANUAL_CLAIM_ITEM_STATUS.PENDING,
  MANUAL_CLAIM_ITEM_STATUS.MONETIZED,
  MANUAL_CLAIM_ITEM_STATUS.TAKENDOWN,
  MANUAL_CLAIM_ITEM_STATUS.REJECTED,
];

/** Sort order options shared by both customer and admin request tables. */
export const MANUAL_CLAIM_SORT_OPTIONS = [
  { api: 'desc', display: 'Newest first' },
  { api: 'asc', display: 'Oldest first' },
];
